export const DEFAULT_INPUT_UNIT_VALUE = 'WEEKS';
export const MIN_DATE_VALUE = 2;
export const MAX_BUSINESS_DAYS_INCREASED = 300;
export const MAX_CALENDAR_DAYS_INCREASED = 400;
export const MAX_WEEKS_INCREASED = 60;
export const OFFLINE_DAYS = ['SATURDAY', 'SUNDAY'];
const defaults = {
  rollingDateValue: MIN_DATE_VALUE,
  rollingDateUnit: 'WEEKS',
  offlineDays: []
};
export default class RollingDateRange {
  constructor(props) {
    var _props$rollingDateVal, _props$rollingDateUni, _props$offlineDays;
    this.rollingDateValue = (_props$rollingDateVal = props === null || props === void 0 ? void 0 : props.rollingDateValue) !== null && _props$rollingDateVal !== void 0 ? _props$rollingDateVal : defaults.rollingDateValue;
    this.rollingDateUnit = (_props$rollingDateUni = props === null || props === void 0 ? void 0 : props.rollingDateUnit) !== null && _props$rollingDateUni !== void 0 ? _props$rollingDateUni : defaults.rollingDateUnit;
    this.offlineDays = (_props$offlineDays = props === null || props === void 0 ? void 0 : props.offlineDays) !== null && _props$offlineDays !== void 0 ? _props$offlineDays : defaults.offlineDays;
  }
  static from(json) {
    return new RollingDateRange(json);
  }
  equals(other) {
    return JSON.stringify(this) === JSON.stringify(other);
  }
  getMaxValueForDateUnit() {
    if (this.offlineDays.length > 0) {
      return MAX_BUSINESS_DAYS_INCREASED;
    } else if (this.rollingDateUnit === 'DAYS') {
      return MAX_CALENDAR_DAYS_INCREASED;
    }
    return MAX_WEEKS_INCREASED;
  }
  buildDateRangeInputsValue() {
    return Object.assign({}, this, {
      rollingDateUnit: this.offlineDays.length >= 1 ? 'BUSINESS_DAYS' : this.rollingDateUnit
    });
  }
  hasValidDateValue() {
    return this.rollingDateValue <= this.getMaxValueForDateUnit();
  }
  validateDateValue() {
    return new RollingDateRange({
      rollingDateUnit: this.rollingDateUnit,
      offlineDays: this.offlineDays,
      rollingDateValue: Math.min(this.rollingDateValue, this.getMaxValueForDateUnit())
    });
  }
  static fromRollingDateRangeInputsValue(rollingDateRange) {
    const {
      rollingDateUnit,
      rollingDateValue
    } = rollingDateRange;
    return new RollingDateRange({
      rollingDateUnit: rollingDateUnit === 'BUSINESS_DAYS' ? 'DAYS' : rollingDateUnit,
      rollingDateValue,
      offlineDays: rollingDateUnit === 'BUSINESS_DAYS' ? OFFLINE_DAYS : []
    });
  }
  static getEmptyRollingDateRange() {
    return new RollingDateRange({
      rollingDateValue: 0,
      rollingDateUnit: 'WEEKS',
      offlineDays: []
    });
  }
}